import { InjectionToken } from "@angular/core";

export const EX_API_URL = new InjectionToken<string>("EX_API_URL");